export default "__VITE_ASSET__417e45a5__"